
import { getAuthenticatedClient } from "../auth/authClient";
var graph = require('@microsoft/microsoft-graph-client');


 export async function getUserDetails(accessToken) {
   const client = getAuthenticatedClient(accessToken);

   const user = await client.api('/me').get();
   return user;
 }